import React from 'react';
import { Popup, Table, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classes from './SortHeader.css';

export const SortTypes = {
  ASC: 'up',
  DESC: 'down',
};

const ColumnLabel = ({ sortChange, children, sortDir }) => (
  <a
    tabIndex={0}
    role="button"
    className={classes.columnHeaderText}
    onClick={sortChange}
  >
    {children}{' '}
    {sortDir &&
      <Icon
        name={`angle ${sortDir}`}
        className={classes.dropdownIconStyle}
        size="small"
      />}
  </a>
);

export const SortHeader = ({
  onSortChange,
  sortDir,
  children,
  description,
  colKey,
  isActive,
  addFixedElement,
  className,
  initialSortDir,
  ...props
}) => {
  const reverseSortDirection = dir => (
    dir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC);

  const sortChange = e => {
    e.preventDefault();
    onSortChange(
      colKey,
      sortDir ? reverseSortDirection(sortDir) : initialSortDir,
    );
  };


  return (
    <Table.HeaderCell
      {...props}
      className={isActive ? `${classes.activeHeader} ${className}` : `${classes.columnHeader} ${className}`}
      onClick={sortChange}
    >
      <span ref={addFixedElement}>
        {description
          ?
            <Popup
              trigger={<a
                tabIndex={0}
                role="button"
                className={classes.columnHeaderText}
                onClick={sortChange}
              >
                {children}{' '}
                {sortDir &&
                  <Icon
                    name={`angle ${sortDir}`}
                    className={classes.dropdownIconStyle}
                    size="small"
                    fitted
                  />}
              </a>}
              position="top center"
              wide
              content={description}
              className={classes.statPopup}
              hideOnScroll
            />
          :
            <ColumnLabel
              sortChange={sortChange}
              sortDir={sortDir}
            >
              {children}
            </ColumnLabel>
        }
      </span>
    </Table.HeaderCell>
  );
};

SortHeader.propTypes = {
  onSortChange: PropTypes.func.isRequired,
  addFixedElement: PropTypes.func,
  sortDir: PropTypes.string,
  children: PropTypes.string.isRequired,
  description: PropTypes.string,
  colKey: PropTypes.string,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  initialSortDir: PropTypes.string,
};

SortHeader.defaultProps = {
  sortDir: '',
  colKey: '',
  description: '',
  isActive: false,
  className: '',
  initialSortDir: SortTypes.DESC,
  addFixedElement: () => {},
};



// WEBPACK FOOTER //
// ./src/app/components/DataTable/SortHeader/SortHeader.js